module.exports = __webpack_public_path__ + "static/media/thankyou.7beb9257.png";